module.exports = __webpack_public_path__ + "img/BeyondLabz_watermark.cf10d2de.jpg";